import { useProductsList } from "modules/products";
import { ItemsTable } from "ui";

import { useProductsColumns } from "../../hooks";
import { StatisticsBlockLayout } from "../../layouts";

import styles from "../../styles/TableStyles.module.scss";

const TopSharedProducts = () => {
  const { products } = useProductsList({
    defaultSorting: [{ id: "totalSharings", desc: true }],
    defaultTake: 5
  });
  const { columns } = useProductsColumns(true);

  return (
    <StatisticsBlockLayout
      title="Top-Shared Products"
      navigationPass="/products"
      navigationOptions={{
        state: { sortBy: "totalSharings", sortOrder: "desc" }
      }}
    >
      <ItemsTable
        columns={columns}
        data={products ?? []}
        isLoading={false}
        className={styles.statistics__table}
        specificColumnsIndexes={[2]}
        specificColumnsClassName={styles.statistics__table__column_right}
      />
    </StatisticsBlockLayout>
  );
};

export default TopSharedProducts;
